// Maps the SPA's client-only `page` state to real URLs and back, and keeps
// <title>/<meta description>/<link rel=canonical>/<meta robots> in sync with
// it. Before this, `page` never touched the URL bar and always started at
// "landing" on load — so /pricing, /help, /privacy, /terms, /refunds,
// /contact all rendered identical content to "/" with no canonical tag,
// which is what Google Search Console flagged as "Duplicate without
// user-selected canonical".
const SITE = "https://freeainow.io";

export const PAGE_PATH = {
  landing: "/",
  pricing: "/pricing",
  help: "/help",
  privacy: "/privacy",
  terms: "/terms",
  refunds: "/refunds",
  contact: "/contact",
  login: "/login",
};

export const PATH_PAGE = Object.fromEntries(
  Object.entries(PAGE_PATH).map(([page, path]) => [path, page]),
);

// `privacy` is intentionally noindex here too — matches the existing
// robots.txt Disallow and nginx X-Robots-Tag for that path.
const PAGE_SEO = {
  landing: {
    title: "Simple Expense Management",
    description:
      "Scan receipts with AI and get clean, categorized expenses and quarterly reports — pay-as-you-go, no subscription.",
  },
  pricing: {
    title: "Pricing | Simple Expense Management",
    description:
      "Pay-as-you-go AI receipt scanning pricing — from $0.022/scan, no monthly subscription.",
  },
  help: {
    title: "Help & FAQ | Simple Expense Management",
    description:
      "Answers to common questions about scanning receipts, mileage tracking, reports and billing.",
  },
  contact: {
    title: "Contact | Simple Expense Management",
    description: "Get in touch with the Simple Expense Management team.",
  },
  terms: {
    title: "Terms of Service | Simple Expense Management",
    description: "Terms of Service for Simple Expense Management.",
  },
  refunds: {
    title: "Refund & Cancellation Policy | Simple Expense Management",
    description: "Refund and cancellation policy for Simple Expense Management.",
  },
  privacy: {
    title: "Privacy Policy | Simple Expense Management",
    description: "Privacy Policy for Simple Expense Management.",
    noindex: true,
  },
  login: {
    title: "Sign in | Simple Expense Management",
    noindex: true,
  },
  trial: {
    title: "Simple Expense Management",
    noindex: true,
  },
};

function setMetaTag(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (content == null) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Called from an effect keyed on `page` — updates head tags to match
// whichever public page is currently showing.
export function applyPageSeo(page) {
  const meta = PAGE_SEO[page] || PAGE_SEO.landing;
  document.title = meta.title;
  setMetaTag("name", "description", meta.description ?? null);
  setMetaTag("name", "robots", meta.noindex ? "noindex, follow" : null);
  setCanonical(SITE + (PAGE_PATH[page] ?? "/"));
}
